import PoolAssignmentCard from './PoolAssignmentCard';

export default PoolAssignmentCard;
